import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type BenchmarkReportingUnitFieldsFragment = { __typename?: 'BenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.BenchmarkReportingCadence };

export type BenchmarkClassificationFacetFieldsFragment = { __typename?: 'BenchmarkClassificationFacet', key: string, value: string };

export type BenchmarkFirmFieldsFragment = { __typename?: 'BenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'BenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'BenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.BenchmarkReportingCadence }> };

export type BenchmarkRosterEntryFieldsFragment = { __typename?: 'BenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.BenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean };

export type BenchmarkCommunityFieldsFragment = { __typename?: 'BenchmarkCommunity', communityId: string, name: string, segment: Types.BenchmarkCommunitySegment, tags: Array<string>, firms: Array<{ __typename?: 'BenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'BenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'BenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.BenchmarkReportingCadence }> }>, roster: Array<{ __typename?: 'BenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.BenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean }> };

export type BenchmarkSubmissionFieldsFragment = { __typename?: 'BenchmarkSubmission', submissionId: string, communityId: string, firmId: string, reportingUnitId: string, periodId: string, version: number, status: Types.BenchmarkSubmissionStatus, submittedByUserId: string, submittedAt?: Types.TDateISO | null, approvalType?: Types.BenchmarkApprovalType | null, approvedByUserId?: string | null, approvedAt?: Types.TDateISO | null, supersededBySubmissionId?: string | null };

export type GetBenchmarkMyCommunitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBenchmarkMyCommunitiesQuery = { __typename?: 'Query', benchmarkMyCommunities: Array<{ __typename?: 'BenchmarkCommunity', communityId: string, name: string, segment: Types.BenchmarkCommunitySegment, tags: Array<string>, firms: Array<{ __typename?: 'BenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'BenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'BenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.BenchmarkReportingCadence }> }>, roster: Array<{ __typename?: 'BenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.BenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean }> }> };

export type GetBenchmarkMyFirmsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBenchmarkMyFirmsQuery = { __typename?: 'Query', benchmarkMyFirms: Array<{ __typename?: 'BenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'BenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'BenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.BenchmarkReportingCadence }> }> };

export type GetBenchmarkSubmissionsQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  reportingUnitId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  periodId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetBenchmarkSubmissionsQuery = { __typename?: 'Query', benchmarkSubmissions: Array<{ __typename?: 'BenchmarkSubmission', submissionId: string, communityId: string, firmId: string, reportingUnitId: string, periodId: string, version: number, status: Types.BenchmarkSubmissionStatus, submittedByUserId: string, submittedAt?: Types.TDateISO | null, approvalType?: Types.BenchmarkApprovalType | null, approvedByUserId?: string | null, approvedAt?: Types.TDateISO | null, supersededBySubmissionId?: string | null }> };

export const BenchmarkClassificationFacetFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkClassificationFacetFields on BenchmarkClassificationFacet {
  key
  value
}
    `, {"fragmentName":"BenchmarkClassificationFacetFields"});
export const BenchmarkReportingUnitFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkReportingUnitFields on BenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
    `, {"fragmentName":"BenchmarkReportingUnitFields"});
export const BenchmarkFirmFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkFirmFields on BenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...BenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...BenchmarkReportingUnitFields
  }
}
    fragment BenchmarkReportingUnitFields on BenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment BenchmarkClassificationFacetFields on BenchmarkClassificationFacet {
  key
  value
}`, {"fragmentName":"BenchmarkFirmFields"});
export const BenchmarkRosterEntryFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkRosterEntryFields on BenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}
    `, {"fragmentName":"BenchmarkRosterEntryFields"});
export const BenchmarkCommunityFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkCommunityFields on BenchmarkCommunity {
  communityId
  name
  segment
  tags
  firms {
    ...BenchmarkFirmFields
  }
  roster {
    ...BenchmarkRosterEntryFields
  }
}
    fragment BenchmarkReportingUnitFields on BenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment BenchmarkClassificationFacetFields on BenchmarkClassificationFacet {
  key
  value
}
fragment BenchmarkFirmFields on BenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...BenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...BenchmarkReportingUnitFields
  }
}
fragment BenchmarkRosterEntryFields on BenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}`, {"fragmentName":"BenchmarkCommunityFields"});
export const BenchmarkSubmissionFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkSubmissionFields on BenchmarkSubmission {
  submissionId
  communityId
  firmId
  reportingUnitId
  periodId
  version
  status
  submittedByUserId
  submittedAt
  approvalType
  approvedByUserId
  approvedAt
  supersededBySubmissionId
}
    `, {"fragmentName":"BenchmarkSubmissionFields"});
export const GetBenchmarkMyCommunitiesDocument = new TypedDocumentString(`
    query GetBenchmarkMyCommunities {
  benchmarkMyCommunities {
    ...BenchmarkCommunityFields
  }
}
    fragment BenchmarkReportingUnitFields on BenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment BenchmarkClassificationFacetFields on BenchmarkClassificationFacet {
  key
  value
}
fragment BenchmarkFirmFields on BenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...BenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...BenchmarkReportingUnitFields
  }
}
fragment BenchmarkRosterEntryFields on BenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}
fragment BenchmarkCommunityFields on BenchmarkCommunity {
  communityId
  name
  segment
  tags
  firms {
    ...BenchmarkFirmFields
  }
  roster {
    ...BenchmarkRosterEntryFields
  }
}`);
export const GetBenchmarkMyFirmsDocument = new TypedDocumentString(`
    query GetBenchmarkMyFirms {
  benchmarkMyFirms {
    ...BenchmarkFirmFields
  }
}
    fragment BenchmarkReportingUnitFields on BenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment BenchmarkClassificationFacetFields on BenchmarkClassificationFacet {
  key
  value
}
fragment BenchmarkFirmFields on BenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...BenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...BenchmarkReportingUnitFields
  }
}`);
export const GetBenchmarkSubmissionsDocument = new TypedDocumentString(`
    query GetBenchmarkSubmissions($communityId: String!, $reportingUnitId: String, $periodId: String, $first: Int, $after: String) {
  benchmarkSubmissions(
    communityId: $communityId
    reportingUnitId: $reportingUnitId
    periodId: $periodId
    first: $first
    after: $after
  ) {
    ...BenchmarkSubmissionFields
  }
}
    fragment BenchmarkSubmissionFields on BenchmarkSubmission {
  submissionId
  communityId
  firmId
  reportingUnitId
  periodId
  version
  status
  submittedByUserId
  submittedAt
  approvalType
  approvedByUserId
  approvedAt
  supersededBySubmissionId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetBenchmarkMyCommunities: build.query<GetBenchmarkMyCommunitiesQuery, GetBenchmarkMyCommunitiesQueryVariables | void>({
      query: (variables) => ({ document: GetBenchmarkMyCommunitiesDocument, variables })
    }),
    GetBenchmarkMyFirms: build.query<GetBenchmarkMyFirmsQuery, GetBenchmarkMyFirmsQueryVariables | void>({
      query: (variables) => ({ document: GetBenchmarkMyFirmsDocument, variables })
    }),
    GetBenchmarkSubmissions: build.query<GetBenchmarkSubmissionsQuery, GetBenchmarkSubmissionsQueryVariables>({
      query: (variables) => ({ document: GetBenchmarkSubmissionsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetBenchmarkMyCommunitiesQuery, useLazyGetBenchmarkMyCommunitiesQuery, useGetBenchmarkMyFirmsQuery, useLazyGetBenchmarkMyFirmsQuery, useGetBenchmarkSubmissionsQuery, useLazyGetBenchmarkSubmissionsQuery } = injectedRtkApi;
